import React, { useState } from "react";
import Sidebar from "components/Sidebar/Siderbar";
import { Outlet, useLocation } from "react-router-dom";
import "./ClientsFlowLayout.css";
import ClientsFlowHeader from "components/Header/ClientsFlowHeader";
import SecondSidebar from "components/Sidebar/SecondSidebar";
import ClientFlowChildHeader from "./ClientFlowChildHeader";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificPage, hasAccessPage } from "utils/checkUserRigths";

function ClientsFlowLayout({ pageName }) {
  // console.log("Inside ClientsFlowLayout ");
  const [isOpenSecondSideBar, setIsOpenSecondSideBar] = useState(true);
  const location = useLocation();
  const state = location.state;
  const innerChnages = state && state.innerChnages ? state.innerChnages : false;

  return (
    <div style={{ position: "fixed", color: "white", width: "100%", display: "flex", justifyContent: "flex-start" }}>
      <div style={{ height: "100vh", width: "auto", display: "flex", position: "relative", alignItems: "flex-end" }}>
        {/* <Sidebar /> */}

        {!innerChnages ? <Sidebar /> : ""}

        {!innerChnages ? <SecondSidebar isOpen={isOpenSecondSideBar} setIsOpen={setIsOpenSecondSideBar} /> : ""}
      </div>

      <div
        style={{
          padding: "0.5rem",
          paddingLeft: "0rem",
          paddingRight: "0rem",
          paddingTop: "0rem",
          height: "100vh",
          width: !innerChnages ? "93.5%" : "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ClientsFlowHeader />

        <div>
          <div
            style={{
              position: "sticky",
              top: 64,
              zIndex: 99,
              background: "black",
              // border: "1px solid red"
            }}
          >
            <ClientFlowChildHeader pageName={pageName} />
          </div>
          <div
            style={{
              height: "100vh",
              // maxHeight: "100vh",
              marginRight: "1.5rem",
              marginLeft: "1.5rem",
              marginBottom: "15px",
              marginTop: "3.3rem",
              // overflow: "auto",
              // overflowX: "hidden",
              // scrollbarWidth: "none",
              // border: "1px solid yellow"
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientsFlowLayout;
